import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import SideMenu from "../components/Menu"
import { fetchSystemInfo } from "../actions/systeminfo";

const mapStateToProps = (state) => {
  return {
    isFetching: state.systemInfo.isFetching,
    systemInfo: state.systemInfo.systemInfo
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSystemInfo
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);
